import { render, staticRenderFns } from "./PaperManageHead.vue?vue&type=template&id=3f30383d&scoped=true"
import script from "./PaperManageHead.vue?vue&type=script&lang=js"
export * from "./PaperManageHead.vue?vue&type=script&lang=js"
import style0 from "./PaperManageHead.vue?vue&type=style&index=0&id=3f30383d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f30383d",
  null
  
)

export default component.exports